<!-- navbar-header -->
<div class="navbar-header" *ngIf="!fuseConfig.layout.navbar.hideHeader" [ngClass]="(fuseConfig?.layout?.navbar?.secondaryBackground || '') + ' ' + (fuseConfig?.layout?.navbar?.headerClass || '')">
    <ng-container *ngIf="fuseConfig.layout.navbar.headerTemplate; else defaultHeader">
        <div fxLayout="row" fxLayoutAlign="center center">
            <ng-container *ngTemplateOutlet="fuseConfig.layout.navbar.headerTemplate"></ng-container>
        </div>
    </ng-container>

    <ng-template #defaultHeader>
        <ng-container *ngIf="fuseConfig.layout.navbar.topMenu.newMenuList.length > 0; else noMenus">
            <div class="cursor-pointer" fxLayout="row" fxLayoutAlign="center center" [matMenuTriggerFor]="userMenu">
                <ng-container *ngTemplateOutlet="navBarTopmenu"></ng-container>
            </div>
        </ng-container>
        <ng-template #noMenus>
            <div class="cursor-pointer" fxLayout="row" fxLayoutAlign="center center">
                <ng-container *ngTemplateOutlet="navBarTopmenu"></ng-container>
            </div>
        </ng-template>

        <mat-menu class="profile-menu" #userMenu="matMenu" [overlapTrigger]="false">
            <ng-container *ngIf="fuseConfig.layout.navbar.topMenu.customMenuComponent">
                <ng-template [cdkPortalOutlet]="fuseConfig.layout.navbar.topMenu.customMenuComponent"></ng-template>
            </ng-container>
            <button
                *ngFor="let menuItem of fuseConfig.layout.navbar.topMenu.newMenuList"
                mat-menu-item
                (click)="customMenuClickEvent(menuItem)"
            >
                <mat-icon>{{ menuItem.icon }}</mat-icon>
                <span>{{ menuItem.text | translate }}</span>
            </button>
            <!-- <button *ngIf="fuseConfig.layout.navbar.topMenu.showMyAccount" mat-menu-item (click)="openMyAccountDialog()">
        <mat-icon>account_circle</mat-icon>
        <span>{{'NAVBAR.MY_ACCOUNT' | translate}}</span>
      </button>
      <button *ngIf="fuseConfig.layout.navbar.topMenu.showAbout" mat-menu-item (click)="openDialog()">
        <mat-icon>info</mat-icon>
        <span>{{'NAVBAR.ABOUT' | translate}}</span>
      </button>
      <button *ngIf="fuseConfig.layout.navbar.topMenu.showMemory && showReportIssueMenu" mat-menu-item class=""
        (click)="openReportDialog()">
        <mat-icon>memory</mat-icon>
        <span>{{'NAVBAR.REPORT_ISSUE' | translate}}</span>
      </button>
      <button *ngIf="fuseConfig.layout.navbar.topMenu.showLogout" mat-menu-item class="" (click)="logout()">
        <mat-icon>{{fuseConfig.layout.navbar.topMenu.logoutIcon}}</mat-icon>
        <span>{{'NAVBAR.LOGOUT' | translate}}</span>
      </button> -->
        </mat-menu>
    </ng-template>

    <button
        *ngIf="!fuseConfig.layout.navbar?.hideMenuIcon"
        mat-icon-button
        class="toggle-sidebar-folded"
        (click)="toggleSidebarFolded()"
        fxHide.lt-lg
    >
        <mat-icon>menu</mat-icon>
    </button>

    <button mat-icon-button class="toggle-sidebar-opened" (click)="toggleSidebarOpened()" fxHide.gt-md>
        <mat-icon>arrow_back</mat-icon>
    </button>
</div>

<!-- navbar-content -->
<div
    class="navbar-content"
    fusePerfectScrollbar
    [fusePerfectScrollbarOptions]="{ suppressScrollX: true }"
    [ngClass]="fuseConfig?.layout?.navbar?.primaryBackground || ''"
>
    <fuse-navigation layout="vertical"></fuse-navigation>

    <div *ngIf="fuseConfig.layout.navbar.hideHeader" fxLayoutAlign="center center">
        <button mat-raised-button class="mt-24 toggle-sidebar-opened" (click)="toggleSidebarOpened()">
            <mat-icon class="primary-text-color mb-4">arrow_back</mat-icon>
        </button>
    </div>
</div>

<!-- navbar-footer -->
<ng-container>
    <div *ngIf="fuseConfig.layout.navbar.bottomMenu?.showfooterNav">
        <ng-container *ngTemplateOutlet="fuseConfig.layout.navbar.bottomMenu.footerNav"></ng-container>
    </div>
</ng-container>

<!-- navbar top-menu template -->
<ng-template #navBarTopmenu>
    <div class="mr-12 cus-avatar" *ngIf="userInfo && userInfo.ProfileImage">
        <img src="{{ userInfo.ProfileImage }}" />
    </div>
    <div
        class="mr-12 cus-avatar"
        *ngIf="userInfo && !userInfo.ProfileImage && !fuseConfig.layout.navbar.profileImageSpinner?.showSpinner"
    >
        <ngx-avatar
            [round]="true"
            size="40"
            [textSizeRatio]="2.5"
            name="{{ userInfo.DisplayName }}"
            value="{{ userInfo.DisplayName }}"
            bgColor="{{ userInfo.ColorCode }}"
            fgColor="#FFFFFF"
            initialsSize="1"
            class="my-avatar"
        >
        </ngx-avatar>
    </div>

    <!-- showing loader instead of avatar while loading profile image -->
    <ng-container>
        <div *ngIf="userInfo && !userInfo.ProfileImage && fuseConfig.layout.navbar.profileImageSpinner?.showSpinner">
            <ng-container
                *ngTemplateOutlet="fuseConfig.layout.navbar.profileImageSpinner.spinnerTemplate"
            ></ng-container>
        </div>
    </ng-container>

    <div>
        <p *ngIf="fuseConfig.layout.navbar.userNameShow" class="username p-0 line-height-18 m-0 text-truncate w-96">
            {{ userInfo.DisplayName || "USER NAME" }}
        </p>
        <p
            *ngIf="userInfo.Designation && fuseConfig.layout.navbar.designationShow"
            class="designation font-size-12 p-0 m-0 line-height-12 text-truncate w-96"
        >
            {{ userInfo.Designation }}
        </p>
    </div>
    <button *ngIf="fuseConfig.layout.navbar.topMenu.newMenuList.length > 0" class="user-profile" mat-icon-button>
        <mat-icon class="s-16 user-profile-drop-down">keyboard_arrow_down</mat-icon>
    </button>
</ng-template>
